import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { urlStringToParsedUrlQuery } from "@catchoftheday/utilities";
import { CatalogueContainer } from "../CatalogueContainer/CatalogueContainer.jsx";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var CataloguePageContainer = function CataloguePageContainer(_ref) {
  var props = _extends({}, _ref);

  var router = useRouter();
  var query = router.query,
      events = router.events;

  var _useState = useState(query),
      queryParams = _useState[0],
      setQueryParams = _useState[1];

  useEffect(function () {
    var handleRouteChange = function handleRouteChange(path) {
      var params = urlStringToParsedUrlQuery(path, window.location.origin);
      setQueryParams(params);
    };

    events.on("routeChangeComplete", handleRouteChange);
    return function () {
      events.off("routeChangeComplete", handleRouteChange);
    };
  }, [events]);
  return ___EmotionJSX(CatalogueContainer, _extends({}, props, {
    queryParams: queryParams
  }));
};